<template>
  <div class="select-language">
    <label for="locale"> {{ t("language") }}</label>
    <select v-model="state.locale">
      <option value="en">{{ t("en") }}</option>
      <!-- <option value="ja">{{ t("ja") }}</option> -->
      <option value="ko">{{ t("ko") }}</option>
      <option value="uz">{{ t("uz") }}</option>
      <option value="ru">{{ t("ru") }}</option>
    </select>
  </div>
</template>

<script lang="ts">
import $API from "@/services";
import { defineComponent, reactive, watch, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { setLocale } from "@vee-validate/i18n";
import { usePrimeVue } from "primevue/config";
import Cookies from "js-cookie";

export default defineComponent({
  name: "Select Language",
  setup() {
    const { locale, t: gt } = useI18n({ useScope: "global" });
    const { t } = useI18n();
    const state = reactive({
      locale: locale,
      t,
    });

    const primevue = usePrimeVue() as any;
    const changeLocale = (locale: string) => {
      setLocale(locale);

      primevue.config.locale.accept = gt("accept");
      primevue.config.locale.reject = gt("reject");
      primevue.config.locale.choose = gt("FileChoose");
      primevue.config.locale.cancel = gt("FileCancel");
      primevue.config.locale.upload = gt("Fileupload");
      primevue.config.locale.emptyMessage = gt("emptyMessage");
      primevue.config.locale.dayNamesShort = gt("dayNamesShort")
        .valueOf()
        .split(",");
      primevue.config.locale.dayNamesMin = gt("dayNamesMin")
        .valueOf()
        .split(",");
      primevue.config.locale.monthNames = gt("monthNames")
        .valueOf()
        .split(",");
      primevue.config.locale.monthNamesShort = gt("monthNamesShort")
        .valueOf()
        .split(",");
    };

    changeLocale(locale.value);

    const setLanguage = async () => {
      const language =
        locale.value === "en"
          ? "en-us"
          : locale.value === "ja"
          ? "ja-jp"
          : locale.value === "uz"
          ? "uz-uz"
          : locale.value === "ru"
          ? "ru-ru"
          : "ko-kr";

      const html = document.getElementsByTagName("html");
      if (html && html.length > 0) {
        html[0].setAttribute("lang", locale.value);
        console.log("setLanguage:setAttribute=>", locale.value);
      }
      console.log("setLanguage=>", language);
      const res = await $API.AccountsService.setLanguage(language);
      console.log(res);
    };

    watch(
      () => state.locale,
      (newLocale: string) => {
        if (newLocale && newLocale.length > 0) {
          const html = document.getElementsByTagName("html");
          if (html && html.length > 0) {
            html[0].setAttribute("lang", newLocale);
          }
        }

        changeLocale(newLocale);
        setLanguage();
        locale.value = newLocale;

        Cookies.set("user-locale", newLocale, { expires: 1, sameSite: "none", secure: true });
      }
    );

    onMounted(async () => {
      let cookieLocale = Cookies.get("user-locale") ?? "";
      if (cookieLocale.length > 0) {
        if (cookieLocale.indexOf("-") > 0) {
          cookieLocale = cookieLocale.substring(0, 2);
        }

        changeLocale(cookieLocale);
        setLanguage();
        locale.value = cookieLocale;
      }
    });

    return { state, t };
  },
});
</script>
<style lang="scss" scoped>
@import "@/styles/variables";
@import "@/styles/mixin";

:focus-visible {
  outline-color: $Grey3;
}

.select-language {
  //position: absolute;
  display: flex;
  margin-left: auto;
  padding: 8px 0px 8px 8px;
  @include mobile {
    padding: 4px 0px 4px 4px;
  }

  > label {
    margin-right: 0.5rem;
    margin-bottom: 0;
    @include mobile {
      display: none;
    }
  }
  > select {
    border-color: $Grey3;
    color: $Grey3;
  }
}
</style>
<i18n>
{
  "en": {
    "language":"Language",
    "en":"English",
    "ko":"Korean",
    "ja":"Japanese",
    "uz":"Uzbek",
    "ru":"Russian"
  },
  "ja": {
    "language":"言語",
    "en":"英語",
    "ko":"韓国語",
    "ja":"日本語",
    "uz":"ウズベク語",
    "ru":"ロシア語"
  },
  "ko":{
    "language":"언어",
    "en":"영어",
    "ko":"한국어",
    "ja":"일본어",
    "uz":"우즈벡어",
    "ru":"러시아어"
  },
  "uz":{
    "language":"Language",
    "en":"English",
    "ko":"Korean",
    "ja":"Japanese",
    "uz":"o'zbek",
    "ru":"Russian"
  },
  "ru":{
    "language":"Language",
    "en":"English",
    "ko":"Korean",
    "ja":"Japanese",
    "uz":"Uzbek",
    "ru":"Russian"
  }
}
</i18n>
